<ng-template #template>
  <div [class]="model.designerCss" [style.maxWidth]="survey.renderedWidth" [style]="model.surfaceCssVariables">
    <div *ngIf="creator.allowEditSurveyTitle" class="svc-designer-header">
      <div *ngIf="survey.renderedHasHeader" [class]="survey.css.header" [survey]="survey" sv-ng-survey-header></div>
    </div>

    <ng-container *ngIf="creator.pageEditMode !== 'bypage'">
      <ng-container *ngFor="let page of model.pages; trackBy: trackPageBy ">
        <ng-container>
          <ng-container
            *ngTemplateOutlet="pageContainer; context: { page, isGhost: model.newPage == page }"></ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="model.pagesController.page2Display && creator.pageEditMode === 'bypage'">
      <svc-designer-pages [model]="model"></svc-designer-pages>
    </ng-container>

  </div>

  <div *ngIf="model.showSurfaceTools" class="svc-tab-designer__tools">
    <div *ngIf="creator.showPageNavigator" class="svc-tab-designer__page-navigator">
      <svc-page-navigator [pagesController]="model.pagesController" [pageEditMode]="creator.pageEditMode">
      </svc-page-navigator>
    </div>
    <div *ngIf="model.showSurfaceToolbar" class="svc-tab-designer__toolbar">
      <sv-action-bar [model]="model.surfaceToolbar"></sv-action-bar>
    </div>
  </div>
</ng-template>

<ng-template let-page="page" let-isGhost="isGhost" #pageContainer>
  <div class="svc-page" [attr.data-sv-drop-target-survey-element]="isGhost ? 'newGhostPage' : page.name"
    [attr.data-sv-drop-target-page]="page.name">
    <ng-template
      [component]="{ name: 'svc-page', data: { model: page, creator, survey, isGhost: isGhost }}"></ng-template>
  </div>
</ng-template>